module.exports = __webpack_public_path__ + "img/backstage.f171cdb5.png";